import { createSlice } from '@reduxjs/toolkit';

const commonSlice = createSlice({
  name: 'common',
  initialState: {
    importLoader: false,
    showRedundantViews: false,
  },
  reducers: {
    enableImportLoader: (state, action) => {
      state.importLoader = action.payload;
    },
    toggleRedundantViews: (state, action) => {
      state.showRedundantViews = !state.showRedundantViews;
    },
  },
});

const {
  reducer: commonReducer,
  actions: { enableImportLoader, toggleRedundantViews },
} = commonSlice;

export { commonReducer, enableImportLoader, toggleRedundantViews };
